import * as React from "react";
import Layout from "../../Layout/layout";
import Section from "../../Layout/Section";
import SectionTitle from "../../Layout/Section/Title";
import Seo from "../../SEO/SEO";
import SolutionHero from "../Hero";
import Capabilities from "../../Tour/Capabilities";
import ProductContent from "../../Product/Content";
import SolutionSlider from "../Slider";
import TemplateString from "../../Common/TemplateString";
import FreeDemoForm from "../../Form/FreeDemo";
import SolutionFeature from "../Feature";
import SolutionAdvantages from "../Advantages";
import SolutionTariffs from "../Tariffs";
import SolutionArticles from "../Articles";
import Faq from "../../Common/faq";

const SolutionPageLayout = ({data, styles}) => {
    const {seo} = data;

    return (
        <Layout className={styles.page}>
            <Seo seo={seo} />
            <SolutionHero
                title={data.title}
                description={data.description}
                media={data.heroMedia}
                variant={data.heroVariant}
                freeDaysCount={data.freeDaysCount}
            />
            {!!data.capabilities && data.capabilities.enabled && (
                <Capabilities
                    sectionTitle={data.capabilities.title || ""}
                    capabilityItems={data.capabilities.items || []}
                    description=""
                    column={2}
                    titleLeft
                    titleMaxWidth="960px"
                    itemImageLeft
                />
            )}
            <SolutionSlider slider={data.slider} />
            <SolutionFeature feature={data.feature} />
            <Section containerClassName={styles.content}>
                {data.contentTitle && (
                    <SectionTitle>
                        <TemplateString template={data.contentTitle} />
                    </SectionTitle>
                )}
                <ProductContent content={data.content} />
            </Section>
            <SolutionAdvantages advantages={data.advantages} />
            <SolutionArticles articles={data.articles} />
            <SolutionTariffs tariffs={data.tariffs} />
            <FreeDemoForm />
            {data.faq && (
                <Section title={<TemplateString template={data.faq.title} />} containerClassName={styles.faq}>
                    <Faq items={data.faq.items} />
                </Section>
            )}
        </Layout>
    );
};

export default SolutionPageLayout;
